import { render, staticRenderFns } from "./ProcessingWaitNotice.vue?vue&type=template&id=3aa96868&scoped=true"
import script from "./ProcessingWaitNotice.vue?vue&type=script&lang=js"
export * from "./ProcessingWaitNotice.vue?vue&type=script&lang=js"
import style0 from "./ProcessingWaitNotice.vue?vue&type=style&index=0&id=3aa96868&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa96868",
  null
  
)

export default component.exports